module.exports = __webpack_public_path__ + "img/1495425112(1).52342632.png";